import React, { useState } from "react";
import './Meme.css';
import MemeData from '../MemeData'

export default function Meme(){
    const [meme, setMeme] = useState({
        topText : "",
        bottomText : "",
        meme_Img : "https://i.imgflip.com/345v97.jpg"
    })                                               

    const [allMemesData, setAllMemeImages] = useState(MemeData);
    function getMeme(){
        const memesArray = allMemesData.data.memes ;
        const meme_url = memesArray[Math.floor(Math.random()*memesArray.length)].url;
        setMeme(function (prevMeme){
            return ({...prevMeme, meme_Img : meme_url});
        });
        console.log(meme_url);
    }

    function textChange(event){
        setMeme(function(prevState){
            return ({
                ...prevState,
                [event.target.name] : event.target.value,
            })
        })
    }
      

    return(
        <main>
        <div className="form">
            <input type="text" placeholder="Top Text" className="form-input" onChange={textChange} name="topText"></input>
            <input type="text" placeholder="Bottom Text" className="form-input" onChange={textChange} name="bottomText"></input>
            <button className="form-button" onClick={getMeme}>Get new Meme Template</button>
        </div>
        <div className="meme-container">
            <h1 className="upperText">{meme.topText}</h1>
            <img src={meme.meme_Img}></img>
            <h1 className="lowerText">{meme.bottomText}</h1>
        </div>
        </main>
    )
}